import { Phone, Mail, Clock } from "lucide-react";
import SEO from "@/components/SEO";
import ContactForm from "@/components/ContactForm";
import { PHONE, PHONE_LINK, EMAIL, BUSINESS_NAME, ORG_SCHEMA } from "@/lib/constants";

const Contact = () => {
  const baseUrl = "https://truamericanplumbing.com";

  const breadcrumbSchema = {
    "@context": "https://schema.org",
    "@type": "BreadcrumbList",
    itemListElement: [
      { "@type": "ListItem", position: 1, name: "Home", item: baseUrl },
      { "@type": "ListItem", position: 2, name: "Contact", item: `${baseUrl}/contact` },
    ],
  };

  return (
    <>
      <SEO
        title="Contact Us - Get a Free Plumbing Quote"
        description="Contact Tru American Plumbing Purifications for plumbing and water purification services in Tolleson and the West Valley. Call (480) 322-2567 or request service online."
        canonicalUrl="/contact/"
        schema={[ORG_SCHEMA, breadcrumbSchema]}
      />

      {/* Hero */}
      <section className="py-16 md:py-20 bg-gradient-to-b from-muted/50 to-background">
        <div className="container">
          <div className="max-w-3xl mx-auto text-center">
            <h1 className="text-4xl md:text-5xl font-bold mb-6">
              Contact <span className="text-gradient-copper">Us</span>
            </h1>
            <p className="text-xl text-muted-foreground">
              Ready to solve your plumbing problems? Get in touch with our team
              today for fast, reliable service.
            </p>
          </div>
        </div>
      </section>

      {/* Contact Info + Form */}
      <section className="py-16 md:py-24">
        <div className="container">
          <div className="grid lg:grid-cols-2 gap-12">
            {/* Contact Info */}
            <div>
              <h2 className="text-2xl font-bold mb-8">Get In Touch</h2>
              
              <div className="space-y-6 mb-12">
                <a
                  href={PHONE_LINK}
                  className="flex items-start gap-4 group"
                >
                  <div className="w-12 h-12 gradient-copper rounded-lg flex items-center justify-center flex-shrink-0">
                    <Phone className="h-5 w-5 text-primary-foreground" />
                  </div>
                  <div>
                    <h3 className="font-bold text-lg group-hover:text-primary transition-colors">
                      Call Us
                    </h3>
                    <p className="text-2xl font-bold text-primary">{PHONE}</p>
                    <p className="text-sm text-muted-foreground">
                      Fast response for all plumbing needs
                    </p>
                  </div>
                </a>

                <a
                  href={`mailto:${EMAIL}`}
                  className="flex items-start gap-4 group"
                >
                  <div className="w-12 h-12 bg-muted rounded-lg flex items-center justify-center flex-shrink-0">
                    <Mail className="h-5 w-5 text-foreground" />
                  </div>
                  <div>
                    <h3 className="font-bold text-lg group-hover:text-primary transition-colors">
                      Email Us
                    </h3>
                    <p className="text-foreground/80">{EMAIL}</p>
                    <p className="text-sm text-muted-foreground">
                      We'll respond within 24 hours
                    </p>
                  </div>
                </a>

                <div className="flex items-start gap-4">
                  <div className="w-12 h-12 bg-muted rounded-lg flex items-center justify-center flex-shrink-0">
                    <Clock className="h-5 w-5 text-foreground" />
                  </div>
                  <div>
                    <h3 className="font-bold text-lg">Business Hours</h3>
                    <p className="text-foreground/80">Monday - Saturday: 7am - 6pm</p>
                    <p className="text-sm text-muted-foreground">
                      Emergency services available
                    </p>
                  </div>
                </div>
              </div>

            </div>

            {/* Form */}
            <div>
              <h2 className="text-2xl font-bold mb-8">Request Service</h2>
              <ContactForm />
            </div>
          </div>
        </div>
      </section>
    </>
  );
};

export default Contact;
